import mongoose from 'mongoose';
import country, { ICountryDocument } from '../schemas/country';

export default (mongoose.models.Country || mongoose.model('Country', country)) as mongoose.Model<
  ICountryDocument
>;
